import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRetiring = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 44 39",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.86 2.849c-4.934 0-10.188 2.402-12.744 6.08a.75.75 0 11-1.232-.857c2.888-4.154 8.648-6.723 13.975-6.723 7.459 0 13.38 5.738 14.665 12.401l3.33-3.842a.75.75 0 111.134.982l-4.421 5.101a.75.75 0 01-1.058.076l-5.101-4.421a.75.75 0 11.982-1.134l3.572 3.096C34.639 7.771 29.37 2.848 22.86 2.848z",
			fill: "#211712"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M35.268 35.211a8.45 8.45 0 100-16.901 8.45 8.45 0 000 16.901zm-4.375-8.17l2.93 2.93a.45.45 0 00.636 0l5.184-5.184a.45.45 0 000-.637l-.638-.638a.45.45 0 00-.637 0L34.14 27.74l-1.974-1.973a.45.45 0 00-.637 0l-.637.637a.45.45 0 000 .638z",
			fill: "#33C252"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.753 26.914c3.018 3.623 7.898 5.849 13.665 5.578a.75.75 0 01.07 1.499c-6.2.29-11.546-2.105-14.888-6.117-3.031-3.64-4.376-8.568-3.25-13.91l-4.453 2.374a.75.75 0 11-.706-1.323l5.956-3.177a.75.75 0 011.015.31l3.176 5.955a.75.75 0 01-1.323.706l-2.259-4.235c-.922 4.79.326 9.132 2.997 12.34z",
			fill: "#211712"
		})
	]
});
export default SvgIconRetiring;
